import { SnippetsOutlined } from '@ant-design/icons';
import React from 'react';
import { AiOutlineExport, AiOutlineUser } from 'react-icons/ai';
import { BsGear } from 'react-icons/bs';

export const options = [
  {
    divider: true,
    onlyUser: true
  },
  {
    title: 'myRequests',
    link: '/my-proposals',
    onlyUser: true,
    icon: <SnippetsOutlined/>,
  },
  {
    divider: true
  },
  {
    title: 'profile',
    action: 'PROFILE',
    icon: <AiOutlineUser/>,
  },
  {
    title: 'administration',
    link: '/cms/admin/pages',
    permissions: ['ADMIN'],
    icon: <BsGear className={'-mb-1'}/>,
  },
  {
    divider: true,
    
  },
  {
    className: 'mt-2',
    title: 'logout',
    action: 'LOGOUT',
    icon: <AiOutlineExport className={'-mb-1'}/>,
  }
];
